export const convertFahrenheitToCelsius = (fahrenheit: number): number => {
    return (fahrenheit - 32) * 5/9;
};

export const convertCelsiusToFahrenheit = (celsius: number): number => {
    return (celsius * 9/5) + 32;
};

export const getPreferredUnit = (): 'F' | 'C' => {
    return localStorage.getItem('temperatureUnit') as 'F' | 'C' || 'F';
};

export const setPreferredUnit = (unit: 'F' | 'C'): void => {
    localStorage.setItem('temperatureUnit', unit);
};

/**
 * Spa setpoints are whole degrees Fahrenheit on the controller, so a converted Celsius value
 * rarely lands on a whole degree. Snapping to the nearest half degree keeps the Celsius ladder
 * moving on every 1F press (no repeated readings) and caps 107F at exactly 41.5C.
 */
export const roundToHalfDegree = (value: number): number => Math.round(value * 2) / 2;

/** Formats a Fahrenheit reading for display: whole degrees in F, half degrees in C. */
export const formatTemp = (fahrenheit: number, unit: 'F' | 'C'): string => {
    return unit === 'C'
        ? roundToHalfDegree(convertFahrenheitToCelsius(fahrenheit)).toFixed(1)
        : String(Math.round(fahrenheit));
};

export const convertToPreferredUnit = (value: number, fromUnit: 'F' | 'C'): number => {
    const preferredUnit = getPreferredUnit();
    if (fromUnit === preferredUnit) return value;
    
    return fromUnit === 'F' 
        ? convertFahrenheitToCelsius(value)
        : convertCelsiusToFahrenheit(value);
}; 